import * as _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Shifts all lights on the map by the specified X and Y offsets in feet.
 *
 * @param x - The horizontal shift offset in feet.
 * @param y - The vertical shift offset in feet.
 * @yields Selects light positions and dispatches shifted coordinates.
 */
function* shiftLights(x, y) {
    try {
        const directionsToMove = {};
        if (x && parseFloat(x) !== 0) directionsToMove.x = parseFloat(x);
        if (y && parseFloat(y) !== 0) directionsToMove.y = parseFloat(y);
        const lights = yield select(({ map }) =>
            _.cloneDeep(map.values.global.present.lights),
        );
        const changedLights = [];
        for (const lightId in lights) {
            if (lightId) {
                const light = lights[lightId];
                for (const direction in directionsToMove) {
                    if (direction) {
                        light.position = {
                            ...light.position,
                            [direction]:
                                light.position[direction] +
                                directionsToMove[direction],
                        };
                    }
                }
                changedLights.push(light);
            }
        }
        yield put(actions.map.values.global.updateLights(lights));
        yield put(
            actions.window.showMessage(
                "Lights were successfully shifted!",
                "success",
                "advanced-operations",
            ),
        );
    } catch {
        yield put(
            actions.window.showMessage(
                "We couldn't shift the lights. Please try again. If you need assistance, please contact support@atrius-iot.com.",
                "error",
                "advanced-operations",
            ),
        );
    }
}

export default shiftLights;
